class CartDrawer extends HTMLElement {
  constructor() {
    super();
    console.log('[CartDrawer Debug] CartDrawer constructor fired. Element upgraded.');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay') || this.querySelector('.cart-drawer__overlay-quooker');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    console.log('[CartDrawer Debug] open() called. triggeredBy:', triggeredBy);
    console.log('[CartDrawer Debug] Current classes:', this.className);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // timeout to ensure active animation starts cleanly
    setTimeout(() => {
      console.log('[CartDrawer Debug] setTimeout firing - adding animate, active classes');
      this.classList.add('animate', 'active');
      console.log('[CartDrawer Debug] Classes after add:', this.className);
      const aside = this.querySelector('.cart-drawer-quooker');
      if (aside) {
        console.log('[CartDrawer Debug] aside transform:', getComputedStyle(aside).transform);
        console.log('[CartDrawer Debug] aside visibility check - drawer visibility:', getComputedStyle(this).visibility);
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? (this.querySelector('.drawer__inner-empty') || this.querySelector('.cart-empty-state-q'))
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close') || this.querySelector('.cart-drawer-close-q');
        if (containerToTrapFocusOn && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (cartDrawerNote.parentElement) {
      cartDrawerNote.parentElement.addEventListener('keyup', typeof onKeyUpEscape === 'function' ? onKeyUpEscape : () => {});
    }
  }

  renderContents(parsedState) {
    console.log('[CartDrawer Debug] renderContents called. parsedState keys:', parsedState ? Object.keys(parsedState) : 'null');
    console.log('[CartDrawer Debug] parsedState.sections:', parsedState.sections);
    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const html = parsedState.sections ? parsedState.sections[section.section || section.id] : null;
      if (html) {
        sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
      }
    });

    // Directly update header cart icon count (it lives in header.liquid, not as standalone section)
    if (parsedState.item_count !== undefined) {
      var cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        var countBubble = cartIconBubble.querySelector('.cart-count-bubble');
        if (countBubble) {
          var countSpan = countBubble.querySelector('[aria-hidden="true"]');
          if (countSpan) countSpan.textContent = parsedState.item_count;
        }
        if (parsedState.item_count > 0) {
          cartIconBubble.classList.remove('is-empty');
        } else {
          cartIconBubble.classList.add('is-empty');
        }
      }
    }

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay') || this.querySelector('.cart-drawer__overlay-quooker');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedDOM = new DOMParser().parseFromString(html, 'text/html');
    const el = selector ? parsedDOM.querySelector(selector) : parsedDOM.body;
    return el ? el.innerHTML : html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer2',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#shopify-section-cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer2',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#shopify-section-cart-icon-bubble',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
